import type { AccountLifecycleStatus } from '@/shared/model/types/accountDeletion';

export const accountLifecycleStatusLabels: Record<AccountLifecycleStatus, string> = {
  active: 'Активен',
  pending_deletion: 'Подлежит удалению',
  deleted: 'Удалён',
};

export const accountDeletionEventLabels: Record<string, string> = {
  deletion_requested_by_player: 'Заявка игрока на удаление',
  deletion_requested_by_superadmin: 'Удаление инициировано супер-администратором',
  deletion_restored: 'Аккаунт восстановлен',
  deletion_finalized: 'Аккаунт обезличен',
};
